'use client';

import type { FC } from 'react';
import { usePathname } from 'next/navigation';
import useTranslation from 'next-translate/useTranslation';
import { Skeleton } from '@eqi-investimentos/react';
import { PATHS } from '@/config/paths';
import { useGetHighlightedContents } from '@/modules/Entertainment/http/client/useGetHighlightedContents';
import { WidgetContainer } from '@/components/molecules/Widget/Container';
import { MostViewedCard } from './Card';
export const MostViewedWidget: FC<MostViewedWidgetProps> = ({
  title
}) => {
  const {
    t
  } = useTranslation('common');
  const pathname = usePathname();
  const {
    data: contents = [],
    isLoading
  } = useGetHighlightedContents(pathname === PATHS.hubs.research ? 'research' : 'home');
  const getSlugMostViewedItem = (id: string, index: number) => {
    const itemSelected = contents[index].items.find(item => item.id === id);
    if (itemSelected?.content?.slug) {
      return itemSelected?.content?.slug;
    }
    return itemSelected?.program?.slug || id;
  };
  if (isLoading) {
    return <WidgetContainer containerId="most-viewed" title={title} removeSeeAllButton>
        {Array.from({
        length: 10
      }).map((_, idx) => <Skeleton key={idx} w="348px" h="124px" borderRadius="0.5rem" />)}
      </WidgetContainer>;
  }
  return contents.map(({
    id,
    items,
    title
  }, idx: number) => <WidgetContainer key={id} containerId={`most-viewed-${id}`} title={title ?? t('widgets.MostViewedWidget.title')} removeSeeAllButton>
      {items.map(({
      id,
      program,
      program_type,
      thumb,
      title,
      type
    }) => <MostViewedCard key={id} programType={program?.type || program_type} slug={getSlugMostViewedItem(id, idx)} thumb={thumb} title={title} type={type} hideCategory={pathname === PATHS.hubs.research} />)}
    </WidgetContainer>);
};
type MostViewedWidgetProps = {
  title?: string;
};